module.exports = __webpack_public_path__ + "c14fb47900dcf547acc02796cde45ef4-playButton.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/common/header/assets/playButton.png
// module id = 535
// module chunks = 0